<template>
  <div class="min-h-screen">
    <!-- 导航栏 -->
    <Navbar />
    <!-- 主内容区 -->
    <main class="pt-[60px] min-h-[calc(100vh-60px)]">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <!-- 底部 - 只在特定路由显示 -->
    <Footer v-if="showFooter" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Navbar from '@/layout/NavBar.vue'
import Footer from '@/layout/Footer.vue'

const route = useRoute()

// 定义需要显示 Footer 的路由路径
const footerRoutes = ['/home']

// 计算是否显示 Footer
const showFooter = computed(() => {
  return footerRoutes.includes(route.path)
})
</script>

<style lang="scss" scoped>
// 页面切换动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
